import { render, staticRenderFns } from "./UserInfoSecurity.vue?vue&type=template&id=1a40e5b0&scoped=true"
import script from "./UserInfoSecurity.vue?vue&type=script&lang=js"
export * from "./UserInfoSecurity.vue?vue&type=script&lang=js"
import style0 from "./UserInfoSecurity.vue?vue&type=style&index=0&id=1a40e5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40e5b0",
  null
  
)

export default component.exports